/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Details_Capability_Granted_DescInputs */



/**
* | output |
* | --- |
* | "A capability was granted to a member, team or role." |
*
* @param {Audit_Details_Capability_Granted_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_capability_granted_desc = /** @type {((inputs?: Audit_Details_Capability_Granted_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Capability_Granted_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Einem Mitglied, Team oder einer Rolle wurde eine Berechtigung erteilt.")
	return /** @type {LocalizedString} */ ("A capability was granted to a member, team or role.")
});